import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1254.000000 1254.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)">


<path d="M10320 12023 c-20 -25 -21 -35 -15 -147 4 -67 8 -127 10 -133 3 -10
37 -13 124 -13 l119 0 21 34 c18 29 21 49 21 160 l0 126 -115 0 -114 0 -4
-122 -3 -123 -2 123 c-1 67 -6 122 -11 122 -5 0 -19 -12 -31 -27z"/>
<path d="M10096 11851 c-5 -7 -5 -100 -1 -206 l7 -192 -114 -6 c-62 -4 -157
-7 -210 -7 -54 0 -98 -3 -98 -7 0 -5 -16 -25 -35 -45 -19 -20 -35 -41 -35 -47
0 -8 73 -11 229 -11 l228 0 28 40 28 40 -2 200 c-2 199 -9 267 -25 241z"/>
<path d="M9603 11645 c0 -38 2 -53 4 -32 2 20 2 52 0 70 -2 17 -4 1 -4 -38z"/>
<path d="M10837 11591 c-24 -29 -25 -32 -20 -163 3 -73 6 -134 7 -135 1 -1 60
-3 130 -4 127 -1 128 -1 157 27 32 31 34 48 23 210 l-7 89 -120 -5 -119 -5 1
-120 c1 -66 0 -117 -3 -114 -3 2 -6 60 -7 127 -1 67 -6 122 -10 122 -4 0 -18
-13 -32 -29z"/>
<path d="M9613 11405 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M10187 11335 l-37 -39 5 -191 c3 -104 8 -209 11 -232 l5 -43 233 0
233 0 32 40 32 40 -8 228 -8 227 -220 1 -220 0 195 -5 195 -6 -160 -9 c-88 -6
-165 -9 -172 -8 -7 2 -9 -6 -6 -18 3 -11 9 -20 14 -20 5 0 9 -9 9 -20 0 -11 7
-20 15 -20 11 0 15 -12 15 -48 0 -39 -5 -53 -25 -70 -14 -12 -25 -26 -25 -32
0 -5 -7 -10 -15 -10 -8 0 -15 -8 -15 -17 0 -15 -2 -16 -10 -3 -7 10 -10 -13
-10 -74 0 -172 -13 -75 -19 146 l-6 223 -38 -40z"/>
<path d="M8380 11343 c-486 -38 -1249 -231 -1829 -463 -485 -193 -1000 -461
-1391 -723 -111 -74 -340 -244 -340 -252 0 -3 53 30 118 74 265 178 545 352
717 446 212 116 249 135 253 130 3 -3 13 2 23 10 20 19 111 63 309 152 407
182 825 327 1265 438 102 26 127 26 38 0 -66 -20 -105 -36 -99 -42 2 -3 13 0
24 6 12 6 31 11 44 10 18 -1 15 -3 -12 -12 -19 -6 -39 -16 -43 -21 -5 -8 -12
-6 -19 4 -8 13 -18 14 -54 6 -28 -7 -43 -15 -40 -23 3 -6 0 -13 -6 -15 -13 -5
-2 -28 13 -28 5 0 9 8 9 18 0 14 10 17 56 18 31 0 50 -2 43 -5 -16 -7 -24 -41
-10 -41 5 0 13 5 17 12 5 7 2 9 -7 4 -8 -4 -5 0 5 8 11 9 27 16 37 16 9 0 31
3 49 7 26 5 31 3 25 -7 -6 -10 8 -11 71 -7 73 6 69 4 -51 -18 -261 -48 -445
-94 -715 -179 -155 -49 -183 -60 -135 -50 55 10 13 -13 -75 -41 -500 -163
-1158 -496 -1615 -818 -128 -91 -324 -247 -395 -315 -67 -65 -65 -64 107 51
141 95 374 240 473 294 831 458 1650 753 2360 852 650 90 1132 24 1411 -196
128 -100 229 -279 241 -428 4 -39 5 -40 41 -38 43 2 45 -2 14 -36 -15 -16 -32
-60 -47 -116 -93 -363 -250 -652 -566 -1037 -68 -84 -128 -164 -131 -178 -3
-14 -24 -48 -45 -77 -21 -29 -38 -55 -38 -57 0 -18 -303 -326 -434 -444 -39
-34 -67 -62 -64 -62 6 0 125 95 138 110 3 3 25 21 50 40 137 106 509 464 639
615 67 78 166 203 224 285 l18 25 -12 -25 c-17 -35 -108 -157 -199 -265 -160
-191 -514 -528 -773 -733 -33 -26 -89 -72 -126 -102 -37 -30 -165 -127 -284
-215 -153 -113 -215 -164 -211 -175 3 -8 7 -23 9 -34 3 -10 9 -24 16 -32 9
-11 7 -14 -12 -15 -21 -1 -20 -2 9 -15 18 -8 38 -12 45 -8 7 3 2 -4 -11 -15
-61 -53 -604 -347 -622 -336 -4 3 -11 19 -15 35 -4 16 -14 34 -23 40 -24 13
-5 12 21 -2 19 -10 20 -9 9 4 -10 13 -10 17 0 21 10 4 10 6 -1 6 -11 1 -11 4
-1 16 17 20 -26 2 -195 -83 -475 -238 -986 -438 -1480 -581 -176 -51 -435
-113 -449 -108 -6 2 5 7 24 12 608 131 1207 350 1890 691 233 117 484 255 615
339 255 163 331 214 483 328 98 74 169 133 165 139 -4 7 -1 8 6 4 7 -5 21 0
33 10 l20 19 -24 6 c-12 4 -195 7 -405 8 l-383 1 0 -117 c0 -65 -3 -148 -6
-184 l-7 -66 -196 -108 c-108 -60 -209 -116 -226 -125 -16 -9 -97 -52 -180
-95 -82 -43 -160 -87 -172 -98 -13 -11 -23 -15 -23 -9 0 7 -5 12 -11 12 -8 0
-7 -5 1 -16 11 -12 10 -18 -3 -32 -16 -15 -17 -5 -15 153 l2 170 6 -120 5
-120 15 60 c13 52 15 237 15 1355 l0 1294 -21 11 c-12 6 -29 17 -38 24 -17 14
-16 15 -29 -29 -3 -10 -7 -5 -12 12 -7 27 -8 27 -73 22 -80 -7 -38 34 -422
-404 -157 -178 -350 -396 -429 -484 -79 -89 -216 -243 -305 -344 l-161 -182
-48 52 c-47 52 -286 328 -737 853 -271 315 -283 329 -382 431 -74 77 -80 81
-111 75 -17 -4 -117 -4 -222 1 -201 9 -613 1 -630 -12 -18 -15 -62 -15 -89 -1
-14 8 -28 12 -30 10 -3 -3 -17 -657 -42 -1904 -3 -154 -9 -509 -14 -788 -4
-279 -10 -511 -13 -514 -11 -10 -96 175 -118 254 -60 223 -20 589 101 922 30
81 39 138 21 126 -23 -14 -180 -249 -224 -335 -26 -52 -45 -81 -41 -65 15 63
97 295 145 407 48 116 57 148 41 148 -14 0 -121 -225 -167 -350 -45 -121 -87
-278 -105 -394 -17 -111 -13 -298 9 -406 23 -110 24 -113 64 -202 21 -48 33
-65 41 -59 8 7 12 2 11 -17 0 -19 5 -27 17 -26 10 1 37 -25 67 -65 27 -36 63
-79 80 -95 17 -16 28 -33 26 -37 -6 -8 47 -49 63 -49 6 0 12 -4 14 -9 6 -16
137 -90 230 -129 190 -81 404 -137 638 -169 169 -23 716 -26 905 -5 1031 114
2123 502 3160 1125 1230 738 2179 1729 2418 2527 48 160 60 240 54 388 -5 155
-19 215 -77 339 -144 308 -458 492 -935 548 -119 14 -491 19 -625 8z m689 -33
c346 -57 616 -203 759 -412 l32 -46 -50 -52 c-28 -29 -50 -57 -50 -62 0 -5
-17 -30 -37 -55 -21 -26 -37 -54 -35 -65 2 -10 -2 -18 -8 -18 -7 0 -9 -8 -5
-21 5 -16 4 -19 -5 -14 -10 6 -11 -3 -6 -41 l6 -49 -18 55 c-24 72 -72 161
-122 228 -42 55 -48 68 -27 56 7 -4 9 -3 4 2 -5 5 -14 9 -20 9 -7 1 -10 7 -8
15 3 8 5 71 6 140 1 108 3 125 17 125 9 0 20 4 25 9 4 5 3 6 -3 3 -7 -4 -18 1
-25 10 -12 14 -11 15 11 9 l25 -7 -24 15 c-14 7 -32 11 -40 8 -8 -3 -12 -1 -8
5 14 22 -210 98 -313 108 -35 3 -46 2 -30 -3 24 -8 24 -9 4 -16 -24 -7 -72
-46 -58 -46 5 0 -4 -9 -21 -20 -16 -11 -30 -24 -30 -29 0 -20 -16 -22 -77 -7
-34 8 -94 22 -131 31 -66 14 -113 37 -111 53 3 17 -20 51 -40 57 -20 7 -20 7
4 16 16 5 -50 7 -175 5 -143 -2 -184 0 -145 6 188 31 533 30 729 -2z m-1384
-120 c-16 -4 -39 -8 -50 -8 -16 0 -15 2 5 8 14 4 36 8 50 8 22 0 22 -1 -5 -8z
m103 -117 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m1629 -720
c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m10 -155 c-2 -24 -4 -7
-4 37 0 44 2 63 4 43 2 -21 2 -57 0 -80z m-5910 -50 c-5 -15 45 -76 202 -252
184 -207 422 -479 465 -532 38 -47 119 -144 476 -568 69 -81 136 -164 150
-182 14 -18 28 -34 31 -34 3 0 50 51 103 113 54 61 108 123 120 137 12 14 78
88 147 165 68 77 138 155 154 174 17 19 107 119 200 223 94 104 171 193 173
197 2 5 30 36 63 69 39 38 58 65 53 73 -4 7 -3 10 4 5 13 -8 83 73 75 88 -3 6
-2 8 2 3 10 -8 45 21 45 37 0 6 9 17 20 24 12 7 18 17 15 22 -3 6 1 10 9 10 8
0 18 5 22 12 5 7 2 8 -7 3 -8 -5 -3 4 10 18 13 15 27 24 32 22 4 -3 11 0 15 6
4 8 3 9 -4 5 -8 -5 -10 -2 -6 8 3 9 9 14 13 11 5 -2 23 11 41 30 19 19 31 35
27 35 -4 0 7 16 24 35 39 42 48 39 20 -6 -12 -19 -21 -39 -21 -45 0 -7 -17
-29 -37 -51 -21 -21 -79 -86 -129 -144 -51 -57 -138 -156 -194 -219 -57 -63
-130 -146 -164 -185 -34 -38 -106 -119 -161 -179 -55 -60 -176 -195 -270 -301
-338 -380 -379 -425 -386 -425 -14 0 -137 141 -544 625 -340 403 -425 501
-346 398 19 -25 29 -48 25 -55 -4 -7 -4 -10 0 -6 10 8 36 -14 29 -25 -2 -4 -1
-17 3 -30 6 -20 8 -20 13 -4 6 17 8 15 20 -9 10 -24 10 -26 -3 -15 -10 8 -16
9 -21 1 -9 -15 -25 -2 -18 15 3 9 -1 15 -11 15 -9 0 -16 5 -16 10 0 6 -13 10
-29 10 -24 0 -32 -7 -50 -45 -12 -25 -30 -50 -41 -57 -11 -7 -20 -18 -20 -25
0 -7 -5 -13 -11 -13 -6 0 -20 -11 -30 -24 -10 -13 -30 -27 -45 -30 -17 -5 -24
-12 -20 -21 4 -13 -58 -95 -73 -95 -8 0 -955 947 -959 959 -2 6 89 10 221 10
124 1 235 4 247 9 12 5 96 9 187 11 132 2 164 -1 160 -11z m5898 -75 c-3 -24
-9 -43 -11 -40 -3 3 -2 29 2 58 4 30 9 48 12 41 2 -7 1 -34 -3 -59z m-18 -85
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-66 -225 c-12 -20 -14
-14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z m-37 -94 c-35 -85 -98 -209 -118
-234 -9 -11 12 39 47 110 35 72 70 145 77 163 7 18 15 31 17 28 2 -2 -8 -32
-23 -67z m-144 -279 c-6 -11 -13 -20 -16 -20 -2 0 0 9 6 20 6 11 13 20 16 20
2 0 0 -9 -6 -20z m-30 -50 c-6 -11 -13 -20 -16 -20 -2 0 0 9 6 20 6 11 13 20
16 20 2 0 0 -9 -6 -20z m-40 -64 c0 -2 -8 -10 -17 -17 -16 -13 -17 -12 -4 4
13 16 21 21 21 13z m-5371 -141 c-9 -8 -40 25 -34 35 5 8 12 4 22 -10 8 -12
13 -23 12 -25z m-219 -427 c0 -218 -17 -1082 -30 -1498 -7 -216 -8 -151 -4
300 6 854 16 1390 26 1390 4 0 8 -87 8 -192z m2695 -1446 c-3 -3 -8 -3 -11 1
-4 3 -3 365 2 804 l9 798 3 -799 c1 -440 0 -801 -3 -804z m-2164 838 c41 -47
97 -112 125 -145 28 -33 158 -186 290 -341 131 -154 282 -332 335 -395 54 -63
107 -123 119 -134 l22 -20 20 25 c11 14 162 193 336 399 175 205 352 414 394
465 43 50 82 90 88 88 5 -1 9 4 8 10 -2 8 5 12 16 10 14 -3 17 1 12 13 -3 9
-2 14 2 11 5 -3 23 8 40 24 17 16 41 31 52 35 12 4 17 11 13 18 -4 7 2 5 12
-3 10 -8 16 -10 12 -4 -9 15 42 25 79 15 l29 -7 3 -528 2 -527 -42 -18 c-24
-10 -122 -48 -218 -85 -676 -260 -1307 -406 -1907 -442 l-113 -6 0 78 c0 202
20 1241 26 1341 3 63 10 110 15 107 5 -3 9 4 9 15 0 33 33 80 68 97 33 15 33
16 16 42 -23 37 43 -30 137 -138z m-1374 -1187 c-2 -21 -4 -4 -4 37 0 41 2 58
4 38 2 -21 2 -55 0 -75z m800 -266 c-2 -23 -3 -1 -3 48 0 50 1 68 3 42 2 -26
2 -67 0 -90z m1233 -43 c-30 -7 -80 -15 -110 -18 -41 -4 -32 -1 35 13 105 21
155 25 75 5z m-205 -35 c-22 -4 -51 -8 -65 -7 -35 1 34 15 75 16 25 0 23 -2
-10 -9z m-102 -16 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-55
-10 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m-59 -7 c-7 -8
-354 -38 -390 -34 -19 2 6 7 56 11 50 4 124 11 165 16 86 9 175 13 169 7z"/>
<path d="M7528 11053 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M11243 10897 l2 -137 -119 0 c-113 0 -122 -1 -158 -26 -21 -15 -38
-30 -38 -35 0 -15 67 -21 175 -16 93 4 109 8 131 28 23 22 24 27 23 153 0 72
-4 140 -9 151 -6 13 -9 -29 -7 -118z"/>
<path d="M6998 10953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11206 10943 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M6870 10920 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M11215 10896 c-4 -18 -2 -53 3 -77 10 -42 10 -41 11 34 1 82 -4 98
-14 43z"/>
<path d="M6758 10903 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M11201 10784 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M10932 10760 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M6290 10699 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M6250 10690 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M10355 10599 l-30 -30 3 -212 c2 -117 6 -222 9 -234 l5 -23 236 0
235 0 33 34 33 34 -5 159 c-3 87 -7 190 -10 228 l-5 70 -197 -3 c-108 -1 -207
-4 -220 -5 l-24 -2 0 -220 c-1 -175 -2 -202 -8 -130 -4 50 -8 152 -9 228 -1
75 -5 137 -9 137 -5 0 -21 -14 -37 -31z"/>
<path d="M7230 10160 c0 -19 -3 -21 -12 -12 -9 9 -17 7 -35 -10 l-23 -21 0
-659 c0 -371 4 -658 9 -658 5 0 14 7 21 15 7 8 21 15 31 15 42 0 42 14 36 688
-4 440 -9 648 -16 655 -8 8 -11 4 -11 -13z"/>
<path d="M8355 10056 l-96 -115 7 -541 7 -540 36 -1 36 -2 -40 -6 c-40 -6 -40
-7 -10 -13 51 -11 225 -6 217 6 -4 6 -10 85 -13 176 l-5 165 0 -168 c1 -92 -2
-167 -5 -167 -11 0 -18 276 -22 810 -3 506 3 463 19 -135 l9 -320 6 235 c4
129 10 264 15 300 7 61 8 63 15 30 5 -19 6 55 3 165 -5 212 -7 218 -55 230
-25 6 -35 -3 -124 -109z"/>
<path d="M10056 9783 c-226 -386 -439 -686 -638 -901 -32 -34 -58 -67 -58 -72
0 -6 30 23 67 62 37 40 113 118 168 173 56 55 126 132 156 170 185 233 381
565 359 605 -6 10 2 34 26 78 19 34 33 62 30 62 -3 0 -52 -80 -110 -177z"/>
<path d="M10126 9855 c-9 -14 -13 -25 -8 -25 5 0 14 11 20 25 6 14 10 25 8 25
-2 0 -11 -11 -20 -25z"/>
<path d="M10101 9622 c-20 -56 -117 -247 -174 -342 -126 -211 -281 -419 -459
-618 l-120 -133 12 -721 c6 -396 8 -723 5 -726 -3 -3 -5 26 -6 64 0 38 -3 63
-6 55 -3 -8 -21 -27 -39 -44 -19 -16 -34 -35 -34 -43 0 -8 -3 -14 -8 -14 -4 0
-15 -18 -25 -40 -13 -30 -23 -40 -40 -40 -17 0 -27 -9 -37 -35 -8 -20 -22 -43
-32 -52 -10 -9 -18 -24 -18 -34 0 -10 -10 -35 -21 -56 -23 -41 -28 -131 -8
-144 8 -4 9 -30 5 -73 -3 -41 -2 -66 4 -66 6 0 10 -5 10 -11 0 -5 -3 -8 -7 -6
-5 3 -17 1 -28 -3 -14 -5 2 -10 50 -14 114 -12 100 -14 -95 -16 -428 -5 -426
-5 -468 -40 l-37 -30 -6 282 c-8 355 -8 801 0 728 6 -58 21 -49 21 12 0 17 3
28 8 24 4 -4 10 -58 13 -119 3 -62 6 64 6 279 l1 392 -254 -172 c-371 -250
-417 -281 -606 -396 -253 -154 -310 -185 -673 -365 -563 -279 -884 -420 -1287
-566 -1040 -377 -2118 -541 -2846 -433 -666 97 -1019 412 -1026 914 -2 173 10
286 38 375 33 102 32 122 0 30 -104 -294 -104 -581 1 -803 72 -153 217 -322
360 -419 128 -87 377 -193 542 -233 29 -6 50 -16 47 -21 -3 -5 6 -9 20 -9 14
0 26 -4 26 -10 0 -5 9 -10 19 -10 11 0 32 -5 48 -12 97 -39 133 -47 214 -48
88 0 203 25 180 39 -7 4 75 11 181 14 346 11 639 49 1018 133 485 108 858 220
1383 418 126 47 232 86 236 86 3 0 8 -62 9 -137 2 -76 7 -141 11 -145 12 -14
983 -13 1008 0 35 20 45 119 47 477 1 244 -2 326 -11 337 -17 20 -6 29 152
118 174 98 576 347 760 470 113 76 102 102 109 -243 3 -166 9 -494 12 -730 4
-235 10 -430 15 -432 13 -8 913 -7 935 1 10 4 63 41 118 83 l98 76 -5 375 c-4
206 -12 684 -18 1061 l-12 686 89 104 c227 265 377 485 501 734 61 121 119
263 111 270 -2 3 -10 -12 -17 -33z m-2916 -2642 c-22 -32 -52 -52 -146 -100
-66 -34 -119 -63 -119 -66 0 -2 14 2 30 11 23 12 35 13 50 5 28 -15 25 -22 -7
-17 -16 2 -22 2 -15 0 6 -3 12 -9 12 -14 0 -5 11 -8 24 -7 14 1 22 6 20 10 -9
13 24 9 38 -5 22 -22 39 -10 26 18 -9 20 -14 22 -33 13 -16 -7 -28 -7 -41 1
-11 7 -13 10 -5 8 8 -2 23 5 34 16 13 13 22 15 31 8 6 -5 18 -6 25 -2 9 6 6
10 -10 14 -13 4 -20 9 -17 12 3 4 16 1 28 -5 16 -9 19 -15 10 -25 -8 -9 -8
-15 0 -20 5 -3 10 -33 10 -66 0 -32 4 -59 9 -59 6 0 9 41 8 95 -2 95 -2 96
-25 90 -13 -3 -21 -2 -18 3 3 5 17 12 31 14 l25 5 0 -203 c0 -112 -1 -205 -2
-205 -2 -1 -177 -5 -391 -8 l-387 -6 0 43 c0 58 -2 55 44 73 23 9 100 44 171
78 432 208 576 286 595 322 7 11 14 18 17 15 3 -3 -7 -24 -22 -46z m2182 -32
c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-2341 -93 c-11 -8 -25
-15 -30 -15 -6 1 0 7 14 15 32 19 40 18 16 0z m2341 -102 c-3 -10 -5 -2 -5 17
0 19 2 27 5 18 2 -10 2 -26 0 -35z m-3025 -315 c-7 -7 -12 -8 -12 -2 0 14 12
26 19 19 2 -3 -1 -11 -7 -17z"/>
<path d="M7140 6618 c-3 -48 -1 -83 3 -79 4 4 7 43 5 87 l-3 79 -5 -87z"/>
<path d="M8541 9514 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2399 8303 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M7460 7609 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M1946 7525 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M2366 6952 c-3 -5 11 -27 30 -48 l36 -39 -23 40 c-29 51 -35 59 -43
47z"/>
<path d="M2470 6820 c6 -11 16 -20 22 -20 6 0 3 9 -7 20 -10 11 -20 20 -22 20
-2 0 1 -9 7 -20z"/>
<path d="M955 5801 c-6 -5 -26 -11 -45 -13 l-35 -3 -7 -135 c-4 -74 -12 -225
-18 -335 -33 -590 -40 -724 -40 -765 l0 -45 89 -37 89 -38 150 0 c120 0 154 3
165 15 10 9 18 46 22 101 4 47 11 80 15 74 6 -9 11 -7 19 9 7 12 16 19 22 16
5 -4 9 2 9 11 0 27 14 7 46 -69 22 -52 35 -69 54 -74 14 -3 56 -19 94 -36 59
-24 77 -28 121 -22 l52 6 46 100 c25 55 50 98 55 97 6 -2 19 8 31 21 l21 24 0
-99 0 -99 69 -37 69 -38 143 1 c201 1 193 -2 201 94 7 87 25 590 35 967 l6
237 -64 40 -64 41 -165 -4 c-91 -2 -185 -7 -211 -11 l-45 -7 -125 -250 -125
-250 -94 227 -95 227 -79 34 -79 34 -162 0 c-88 0 -165 -4 -170 -9z m321 -39
c1 -15 33 -101 72 -192 119 -280 203 -491 200 -502 -2 -6 -20 27 -40 73 -73
170 -207 476 -237 542 -29 62 -33 67 -52 56 -15 -8 -19 -8 -15 0 5 8 -36 11
-143 11 -114 0 -151 3 -151 13 0 9 39 12 163 12 129 0 202 5 202 14 0 1 0 -11
1 -27z m980 -89 c-3 -59 -11 -315 -17 -568 -6 -253 -13 -462 -16 -465 -5 -5
-1 269 14 853 l6 257 -171 -1 c-166 -1 -170 -2 -176 -22 -3 -12 -12 -31 -21
-42 l-16 -20 9 20 c6 11 16 36 24 55 l15 35 178 3 178 4 -7 -109z m-1019 45
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-87 -750 c-7 -120 -15
-218 -18 -218 -7 0 8 470 16 505 14 58 14 -62 2 -287z m766 253 c-15 -28 -28
-51 -31 -51 -3 0 7 25 22 55 15 30 29 53 31 51 2 -2 -8 -27 -22 -55z m-89
-173 c-30 -57 -67 -127 -81 -156 -15 -30 -30 -52 -33 -49 -2 3 32 76 77 162
45 86 84 154 87 151 3 -2 -20 -51 -50 -108z m-700 -400 c-2 -13 -4 -5 -4 17
-1 22 1 32 4 23 2 -10 2 -28 0 -40z"/>
<path d="M2534 5799 l-31 -9 -7 -142 c-7 -165 -22 -604 -31 -923 l-6 -220 58
-34 58 -34 165 -5 c197 -6 200 -4 201 86 0 65 11 134 20 130 3 -2 18 12 34 30
23 27 30 31 44 20 13 -10 14 -10 4 2 -7 8 -13 21 -13 30 1 23 23 -9 85 -125
52 -95 85 -133 144 -165 32 -17 366 -9 384 9 9 9 4 27 -21 74 -18 34 -67 126
-109 205 l-75 143 46 47 c55 56 130 198 146 279 7 31 10 96 8 144 -6 122 -41
192 -147 291 -92 86 -191 143 -288 163 -78 17 -615 20 -669 4z m714 -46 c34
-12 62 -18 62 -14 0 3 4 1 8 -5 4 -5 24 -20 44 -33 76 -46 148 -165 148 -244
0 -25 -6 -16 -26 43 -41 123 -144 210 -282 239 -32 7 -173 11 -362 11 -273 0
-310 2 -310 15 0 14 37 16 328 12 299 -3 332 -5 390 -24z m-707 -83 c-6 -30
-9 -36 -10 -19 -1 33 12 99 16 79 2 -8 -1 -35 -6 -60z m269 -301 c0 -88 -3
-158 -7 -156 -8 5 -5 317 2 317 3 0 5 -72 5 -161z m355 -92 c-23 -36 -58 -47
-138 -46 -40 1 -62 4 -49 6 13 3 32 13 43 24 16 16 32 20 75 18 31 -2 60 3 66
9 19 19 20 14 3 -11z m-50 -80 c-26 -16 -315 -24 -315 -8 0 7 53 12 153 14 83
1 159 3 167 4 9 2 8 -2 -5 -10z m253 -379 c108 -188 135 -238 128 -238 -2 0
-21 30 -42 68 -21 37 -75 129 -120 205 -45 75 -79 137 -74 137 4 0 53 -78 108
-172z m-577 -18 c-6 -103 -8 -117 -9 -60 -2 76 9 223 14 205 2 -6 0 -71 -5
-145z"/>
<path d="M4205 5803 c-16 -3 -33 -8 -36 -11 -4 -4 -10 -164 -14 -357 -4 -192
-10 -478 -14 -635 -9 -310 -10 -302 47 -344 20 -15 49 -19 156 -23 72 -3 149
-1 171 4 l40 9 9 174 c8 171 9 176 37 211 17 22 43 40 67 47 54 16 208 16 218
0 6 -9 10 -5 15 12 4 14 7 -67 8 -180 l1 -206 29 -34 28 -34 166 -1 c107 0
170 4 177 11 7 7 14 207 20 640 l9 629 -22 40 c-21 37 -26 40 -77 47 -70 8
-236 8 -275 -1 l-30 -6 -6 -160 c-4 -88 -7 -195 -8 -237 l-1 -78 -170 0 -170
0 0 208 0 208 -34 37 -34 37 -138 -1 c-77 -1 -152 -4 -169 -6z m277 -154 c-5
-203 -20 -246 -21 -62 -1 83 -5 154 -9 157 -16 10 -31 -10 -35 -49 l-4 -40 -1
45 -2 45 -100 1 c-84 1 -99 -1 -89 -12 8 -9 8 -14 1 -14 -6 0 -11 -26 -12 -62
0 -35 -4 -81 -8 -103 -5 -27 -8 3 -7 90 l0 130 145 3 145 3 -3 -132z m760 4
c-4 -170 -9 -187 -11 -36 0 67 -4 124 -8 126 -5 3 -7 -23 -6 -56 1 -51 0 -56
-6 -27 -5 19 -9 28 -10 19 -1 -12 -11 -16 -41 -16 -32 0 -40 3 -40 18 0 26
-31 24 -37 -1 -4 -15 -9 -18 -18 -10 -10 8 -18 4 -33 -15 -18 -23 -21 -24 -30
-9 -7 13 -12 1 -21 -52 -6 -38 -12 -85 -14 -104 -2 -19 -5 38 -5 128 l-2 162
143 0 143 0 -4 -127z m-795 35 c-2 -13 -4 -5 -4 17 -1 22 1 32 4 23 2 -10 2
-28 0 -40z m-50 26 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m553 -424 c10 -6 -41 -10 -155 -11 -93 -1 -205 -3 -247 -5 -71 -2 -98 6 -65
19 23 10 452 7 467 -3z m-483 -377 c-2 -21 -4 -4 -4 37 0 41 2 58 4 38 2 -21
2 -55 0 -75z m341 -10 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z"/>
<path d="M5110 5729 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5888 5803 c-42 -5 -23 35 -204 -438 -58 -154 -158 -409 -220 -568
-63 -158 -114 -293 -114 -301 0 -7 10 -26 21 -40 l22 -28 168 4 c134 2 171 6
182 18 8 8 24 43 37 77 12 35 26 60 31 57 5 -3 12 2 15 11 4 9 28 27 55 40 43
22 61 25 158 25 110 0 215 -16 205 -32 -3 -4 -1 -8 5 -8 5 0 21 -37 36 -82 15
-46 34 -89 43 -95 19 -16 307 -18 346 -3 15 5 31 21 38 35 10 22 3 47 -55 197
-278 730 -349 916 -384 1007 -21 58 -44 106 -51 109 -18 6 -15 -31 8 -90 28
-74 25 -83 -7 -18 -14 30 -26 58 -25 63 1 4 -68 6 -154 5 l-156 -3 -59 -145
c-33 -80 -101 -250 -151 -379 -51 -129 -93 -230 -95 -224 -2 5 11 43 28 84 17
41 41 103 54 139 13 36 51 135 85 220 100 252 128 329 121 336 -3 3 3 5 14 4
11 -1 86 -2 168 -1 100 1 147 5 147 12 0 6 -7 9 -15 6 -8 -4 -17 -2 -20 3 -6
10 -197 11 -277 3z m321 -798 c2 -3 -72 -5 -165 -4 -93 1 -158 4 -144 8 26 8
301 4 309 -4z m-645 -74 c-9 -23 -18 -40 -20 -38 -2 2 4 22 13 45 9 23 18 40
20 38 2 -2 -4 -22 -13 -45z"/>
<path d="M6803 5800 c-12 -5 -26 -18 -32 -29 -8 -13 -11 -229 -11 -671 l0
-650 26 -10 c29 -11 175 -13 275 -4 87 9 99 26 99 151 0 48 3 105 6 125 l6 36
50 -2 c40 -2 54 -7 69 -27 16 -20 18 -20 13 -4 -8 24 37 -36 126 -165 36 -52
76 -100 90 -107 17 -9 81 -13 202 -13 l178 0 40 36 40 36 0 -26 c0 -19 7 -29
26 -36 15 -6 197 -10 447 -10 l422 0 48 38 48 37 -6 140 c-3 77 -9 143 -14
148 -10 10 -181 26 -301 28 -81 2 -87 3 -40 8 30 3 66 13 80 22 14 9 40 23 58
30 17 8 32 20 32 26 0 7 4 13 9 13 6 0 30 21 55 48 l45 47 -6 140 c-4 84 -10
143 -17 147 -6 4 -72 9 -146 10 -74 1 -112 3 -85 5 55 5 179 58 170 73 -3 6 2
10 12 10 10 0 41 24 68 53 l50 52 -5 140 c-5 130 -6 140 -25 143 -11 2 -29 8
-41 13 -13 7 -168 9 -432 7 l-412 -3 -31 -32 -32 -31 11 -614 c5 -337 9 -614
8 -615 -1 -1 -50 66 -108 150 -59 84 -159 226 -223 317 -141 200 -150 217
-134 236 6 7 16 11 22 7 5 -3 7 -1 3 5 -6 10 10 26 26 27 3 0 10 4 15 9 5 5 3
6 -4 2 -25 -14 -12 7 48 83 34 42 66 75 73 73 6 -2 8 0 4 3 -10 10 41 75 55
72 7 -1 11 4 9 11 -1 7 34 61 79 120 44 58 75 108 70 110 -8 3 -7 10 0 24 14
26 -3 39 -46 37 -16 -1 -37 1 -45 5 -9 4 -85 5 -170 4 l-154 -3 -50 -61 c-28
-33 -103 -128 -166 -212 l-115 -151 -5 199 c-3 109 -7 200 -10 202 -36 26
-293 40 -347 18z m187 -21 c122 2 139 0 134 -14 -6 -15 -68 -20 -220 -17 l-50
1 -3 -402 c-1 -221 -5 -404 -7 -406 -2 -2 -4 181 -4 407 0 225 -3 418 -7 428
-4 12 -3 15 6 10 7 -4 75 -7 151 -7z m727 0 c124 -2 150 -5 141 -16 -8 -10
-50 -13 -167 -13 l-157 0 -154 -196 c-85 -107 -172 -217 -192 -244 -36 -47
-71 -80 -52 -49 4 8 93 125 196 261 103 136 188 252 188 259 0 7 9 9 23 6 12
-4 90 -7 174 -8z m861 1 c177 -1 322 -5 322 -9 0 -10 -287 -21 -567 -21 -146
0 -224 -4 -228 -11 -4 -6 -7 -243 -8 -527 0 -413 -2 -473 -7 -297 -4 121 -8
362 -9 536 -1 193 -5 319 -11 325 -6 6 23 9 88 7 53 -1 242 -3 420 -3z m-1659
-49 c9 -6 4 -10 -17 -13 -22 -3 -29 -1 -25 9 6 15 22 17 42 4z m1931 -451 c0
-6 -85 -10 -236 -10 -154 0 -233 3 -229 10 4 6 93 10 236 10 146 0 229 -4 229
-10z m-50 -500 c0 -6 -75 -10 -205 -10 -130 0 -205 4 -205 10 0 6 75 10 205
10 130 0 205 -4 205 -10z m68 3 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32
-1 23 -4z"/>
<path d="M9038 5777 c-36 -27 -44 -39 -47 -72 -4 -44 17 -1043 24 -1169 3 -43
10 -85 16 -93 9 -10 94 -13 451 -13 l440 0 59 38 58 37 -1 115 c0 63 -3 128
-7 145 -8 37 -26 41 -216 51 -100 6 -127 10 -94 14 44 5 116 51 118 74 1 10
36 44 86 82 33 25 35 30 35 83 0 124 -12 220 -29 227 -9 4 -70 10 -136 13 -99
6 -113 8 -80 15 45 9 145 54 145 65 0 4 32 31 70 60 l70 52 0 68 c0 37 -3 102
-6 144 l-7 77 -33 0 c-19 0 -34 5 -34 10 0 7 -146 10 -419 10 l-419 0 -44 -33z
m854 -2 c42 0 74 -3 70 -6 -8 -8 -384 -19 -632 -19 l-175 0 1 -432 c1 -380 0
-405 -6 -203 -5 127 -10 328 -12 447 l-5 217 116 4 c64 1 217 0 341 -3 124 -3
260 -5 302 -5z m23 -495 c4 -7 -77 -10 -234 -10 -154 0 -241 4 -241 10 0 6 85
10 234 10 146 0 237 -4 241 -10z m-748 -597 c-2 -27 -3 -5 -3 47 0 52 1 74 3
48 2 -27 2 -69 0 -95z m663 97 c10 -6 -51 -10 -183 -10 -130 0 -196 3 -192 10
8 13 355 13 375 0z"/>
<path d="M10095 5777 l-50 -32 -3 -88 c-1 -48 6 -338 17 -645 18 -481 23 -559
37 -569 10 -7 70 -12 170 -12 l154 -2 71 42 71 41 -5 122 c-3 66 -3 113 -1
103 3 -9 10 -14 16 -10 8 4 9 0 5 -11 -4 -11 -1 -19 9 -23 9 -3 40 -57 69
-118 52 -111 53 -113 91 -119 49 -8 233 53 249 82 6 10 35 76 65 145 l55 126
10 -177 c6 -97 14 -183 18 -189 6 -10 52 -13 171 -13 l163 0 85 40 85 39 -5
78 c-2 43 -16 330 -31 638 l-26 560 -47 3 c-27 2 -48 7 -48 13 0 5 -71 9 -172
9 l-173 -1 -69 -37 -69 -37 -86 -217 c-48 -119 -89 -219 -92 -222 -3 -4 -60
106 -127 244 l-121 250 -40 0 c-22 0 -43 5 -46 10 -4 6 -74 10 -178 10 l-172
0 -50 -33z m250 -1 c61 -2 134 -5 163 -5 28 -1 52 -5 52 -11 0 -6 -61 -10
-164 -10 l-163 0 3 -407 c2 -225 2 -403 -1 -398 -2 6 -9 191 -14 413 -7 298
-12 407 -22 418 -11 13 -9 14 12 10 13 -4 74 -8 134 -10z m1060 -6 l150 -3
-110 -7 c-60 -4 -135 -8 -166 -9 l-56 -1 -58 -132 c-32 -73 -91 -209 -133
-303 -41 -93 -83 -190 -94 -214 -10 -24 -21 -42 -24 -39 -2 3 60 158 139 344
79 187 147 346 150 355 3 10 15 15 29 14 13 -1 91 -4 173 -5z m-88 -760 l0
-125 -7 100 c-4 55 -7 145 -7 200 l0 100 7 -75 c4 -41 7 -131 7 -200z m-749
185 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m759 -457 c-2 -24
-4 -7 -4 37 0 44 2 63 4 43 2 -21 2 -57 0 -80z m10 -180 c-2 -13 -4 -3 -4 22
0 25 2 35 4 23 2 -13 2 -33 0 -45z"/>
<path d="M3700 4225 c-7 -8 -10 -21 -7 -29 3 -8 1 -158 -5 -333 -5 -175 -11
-339 -12 -365 0 -30 -5 -43 -11 -37 -5 5 -48 9 -96 9 l-87 0 3 378 c4 409 -7
342 -20 -135 l-8 -271 29 -27 c28 -25 33 -26 136 -23 60 2 112 8 118 14 13 13
29 360 30 625 l0 177 -25 16 c-30 20 -30 20 -45 1z"/>
<path d="M5493 4233 c37 -2 96 -2 130 0 34 2 4 3 -68 3 -71 0 -99 -1 -62 -3z"/>
<path d="M5702 4213 c-6 -16 -10 -37 -10 -48 1 -11 1 -39 0 -62 l-2 -43 -106
0 -106 0 3 -37 c1 -21 1 -154 0 -295 l-1 -258 -95 0 -95 0 0 294 0 294 -105
-1 -105 -2 0 82 c0 45 -4 85 -10 88 -6 4 -10 -30 -10 -95 0 -87 3 -105 23
-135 17 -26 31 -35 62 -40 22 -3 53 -11 68 -17 22 -9 31 -8 36 1 13 20 21
-100 21 -313 0 -111 4 -208 9 -215 7 -11 34 -16 103 -17 146 -4 138 -15 138
179 0 199 10 353 21 335 7 -10 9 -9 9 4 0 23 85 68 129 68 20 0 42 5 49 12 18
18 16 222 -2 237 -11 9 -16 6 -24 -16z"/>
<path d="M6582 4228 c-9 -9 -12 -115 -12 -409 0 -348 2 -400 16 -413 22 -23
520 -19 534 4 5 8 10 64 10 124 0 95 -2 107 -15 96 -11 -9 -15 -33 -15 -86 l0
-74 -229 0 c-126 0 -236 -3 -245 -6 -14 -6 -16 31 -16 372 0 209 -4 385 -8
391 -6 10 -11 10 -20 1z"/>
<path d="M6653 4233 c20 -2 54 -2 75 0 20 2 3 4 -38 4 -41 0 -58 -2 -37 -4z"/>
<path d="M7456 4221 c-15 -16 -16 -56 -16 -403 1 -302 4 -389 14 -403 11 -15
32 -19 123 -23 105 -4 111 -3 131 19 19 19 22 35 22 103 0 83 4 97 30 106 21
7 139 4 147 -4 4 -4 9 -49 11 -101 3 -69 9 -98 20 -107 10 -9 49 -13 116 -13
85 0 106 3 129 20 l29 20 -7 390 c-3 215 -10 394 -15 399 -19 20 -23 -61 -16
-401 l7 -353 -83 0 c-52 0 -89 -5 -96 -12 -9 -9 -12 23 -12 145 l0 157 -145 0
-145 0 0 -144 0 -145 -92 -3 c-51 -2 -94 -3 -95 -3 -1 1 -5 167 -8 370 -4 204
-8 375 -10 382 -3 9 25 13 103 16 l107 3 -116 2 c-102 2 -118 0 -133 -17z"/>
<path d="M7927 4222 c-13 -14 -17 -44 -19 -142 l-3 -125 -87 -3 -88 -3 0 79
c0 105 -11 203 -21 196 -5 -3 -9 -71 -9 -151 0 -128 2 -144 16 -139 9 3 72 6
140 6 l125 0 -3 145 -3 144 95 4 95 3 -111 2 c-96 2 -113 0 -127 -16z"/>
<path d="M8287 4225 c-18 -13 -19 -30 -15 -282 4 -249 6 -272 27 -325 60 -154
227 -247 421 -236 89 5 150 30 210 84 106 96 125 167 116 439 -8 240 -15 317
-28 309 -5 -4 -8 -111 -6 -277 3 -266 2 -273 -20 -322 -13 -27 -37 -65 -54
-83 -84 -86 -297 -105 -414 -37 -64 38 -132 119 -148 179 -10 33 -18 137 -23
303 l-8 252 95 4 95 3 -115 2 c-85 1 -120 -2 -133 -13z"/>
<path d="M8745 4220 c-17 -19 -18 -37 -12 -269 l7 -249 -25 -26 c-31 -33 -77
-35 -109 -3 -22 22 -23 30 -30 282 -3 142 -9 261 -12 264 -18 18 -23 -48 -18
-249 7 -276 12 -298 84 -329 59 -25 68 -26 120 -5 30 12 46 27 61 56 19 37 20
52 14 288 l-7 249 73 4 c66 3 63 3 -27 5 -90 2 -103 0 -119 -18z"/>
<path d="M9103 4223 c-17 -17 -17 -44 -10 -408 6 -327 10 -392 23 -405 12 -13
56 -15 272 -15 l257 0 57 28 c61 30 122 90 144 143 27 65 6 203 -35 228 -15
10 -14 5 7 -35 26 -51 22 -133 -8 -189 -19 -34 -38 -52 -79 -72 l-55 -28 -221
0 c-157 0 -224 -3 -233 -12 -6 -6 -15 -8 -19 -4 -4 4 -9 168 -11 364 -2 196
-7 369 -12 384 l-9 28 177 3 177 2 -202 3 c-182 2 -205 0 -220 -15z"/>
<path d="M3117 4216 c178 -59 286 -260 229 -424 -47 -132 -112 -221 -196 -268
-78 -44 -139 -54 -334 -54 l-179 0 7 208 c3 114 9 283 13 376 4 115 3 167 -4
163 -6 -4 -11 -56 -12 -124 -1 -65 -6 -206 -11 -313 -5 -107 -10 -229 -10
-271 l0 -75 43 -20 c37 -17 64 -19 227 -18 238 0 321 22 423 112 23 20 36 28
28 17 -8 -11 5 0 28 25 24 25 48 56 53 70 16 39 21 244 7 308 -6 31 -22 76
-35 98 -54 92 -183 184 -279 198 l-40 6 42 -14z"/>
<path d="M4737 4102 c-4 -70 -7 -251 -7 -403 0 -237 2 -278 15 -289 22 -18
219 -20 237 -2 9 9 14 96 21 320 10 361 6 467 -17 491 -13 13 -18 13 -25 3 -4
-7 -11 -144 -15 -305 -3 -161 -9 -327 -13 -369 l-6 -78 -90 0 -90 0 5 375 c5
371 -3 503 -15 257z"/>
<path d="M5957 4223 c-3 -4 -39 -98 -81 -208 -42 -110 -106 -275 -142 -366
-67 -172 -83 -232 -66 -243 5 -3 54 -8 108 -11 120 -7 141 1 162 65 9 25 17
39 20 32 2 -8 8 -10 15 -4 22 18 217 44 217 30 0 -5 5 -7 11 -6 7 2 26 -24 43
-57 l31 -60 112 -3 c105 -2 113 -1 123 18 14 26 18 13 -142 434 -140 369 -151
395 -162 378 -4 -6 19 -76 50 -154 62 -158 126 -326 185 -490 l38 -108 -98 0
-98 0 -24 70 -24 70 -150 0 -150 0 -24 -66 c-13 -36 -28 -67 -35 -69 -6 -2
-52 -5 -101 -7 l-91 -3 12 35 c7 19 40 107 74 195 34 88 76 201 95 250 18 50
50 132 70 183 20 52 35 96 32 98 -3 3 -7 2 -10 -3z"/>
<path d="M6808 4224 c-5 -4 -8 -138 -8 -298 l0 -291 152 4 c174 4 167 18 -9
20 l-113 1 -1 258 c-1 251 -6 322 -21 306z"/>
<path d="M9726 4173 c38 -34 68 -104 67 -158 0 -60 -21 -104 -64 -138 l-31
-24 28 -7 c24 -6 32 -3 51 21 28 34 43 83 43 139 0 53 -43 138 -83 165 -26 17
-28 17 -11 2z"/>
<path d="M4510 4176 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M4556 4138 c3 -10 9 -18 13 -18 3 0 12 -10 20 -22 13 -21 13 -22 -2
-10 -19 16 -22 14 -106 -51 -43 -35 -67 -48 -76 -41 -85 63 -97 68 -164 68
-86 0 -148 -33 -187 -100 -24 -41 -26 -52 -22 -129 4 -78 7 -86 41 -128 58
-71 141 -100 224 -78 50 14 113 69 113 100 0 22 -3 22 -90 19 l-90 -3 0 78 0
77 188 0 187 0 -7 -172 c-7 -168 -14 -238 -24 -238 -12 0 -61 30 -73 44 -12
14 -17 13 -46 -10 -71 -54 -200 -82 -303 -65 -172 28 -280 129 -318 299 -19
85 -9 172 31 260 30 65 24 69 -9 5 -35 -71 -49 -148 -44 -250 3 -72 9 -99 31
-141 15 -28 25 -57 22 -64 -5 -15 43 -74 52 -64 3 3 22 -9 41 -26 20 -17 65
-44 100 -61 52 -24 81 -31 158 -35 105 -5 160 5 249 49 59 29 60 29 102 13 75
-29 80 -14 89 273 7 193 10 184 -75 198 -24 4 -39 10 -34 14 9 6 25 37 27 53
1 3 13 16 29 28 37 29 34 53 -13 103 -22 23 -37 34 -34 25z m-396 -381 c13 3
20 0 21 -8 0 -8 4 -5 9 6 8 18 9 18 10 -5 0 -14 7 -42 14 -62 13 -36 13 -38
-8 -38 -44 0 -96 62 -96 115 0 15 2 15 15 2 8 -9 24 -13 35 -10z"/>
<path d="M9382 3998 l3 -73 75 -3 c114 -5 167 33 140 102 -14 37 -40 46 -135
46 l-87 0 4 -72z"/>
<path d="M2850 4058 c-6 -135 -3 -418 5 -419 34 -4 145 4 171 12 17 5 45 24
62 42 103 106 73 299 -53 347 -27 10 -185 26 -185 18z m274 -275 c-17 -72 -74
-123 -136 -123 -22 0 -28 3 -20 9 8 4 13 10 12 12 -1 2 3 23 9 45 13 48 48 77
74 62 12 -6 17 -5 17 3 0 9 3 9 14 0 10 -9 15 -8 20 4 9 25 17 17 10 -12z"/>
<path d="M6062 3953 c-11 -32 -31 -88 -45 -125 l-26 -68 94 0 94 0 -41 118
c-23 64 -44 121 -48 125 -4 5 -17 -18 -28 -50z"/>
<path d="M985 3910 c-4 -7 217 -10 656 -10 516 0 660 -3 651 -12 -7 -7 -12
-36 -12 -65 l0 -53 -262 -2 c-145 -1 -455 0 -690 2 -248 1 -428 -1 -428 -6 1
-5 17 -19 36 -31 l35 -23 690 0 c457 0 697 4 710 10 16 9 19 22 19 92 0 65 -3
83 -17 94 -15 11 -149 13 -700 14 -444 0 -684 -3 -688 -10z"/>
<path d="M10108 3909 c-15 -8 -18 -24 -18 -92 0 -51 5 -88 12 -95 16 -16 1403
-18 1413 -1 4 5 18 14 32 20 23 9 24 13 21 74 -4 81 -22 90 -26 13 l-3 -58
-669 0 -670 0 0 65 c0 47 4 65 13 64 6 -1 297 -1 645 0 414 1 632 4 632 11 0
14 -1359 13 -1382 -1z"/>
<path d="M9390 3694 l0 -87 102 7 c110 7 144 20 154 60 19 77 -25 106 -163
106 l-93 0 0 -86z"/>
<path d="M3840 3598 c0 -9 5 -20 10 -23 13 -8 13 5 0 25 -8 13 -10 13 -10 -2z"/>
<path d="M3253 3159 c-310 -46 -567 -304 -612 -614 -8 -59 -9 -59 -10 -15 -1
33 -4 41 -11 30 -14 -22 -13 2 5 79 19 80 14 90 -8 14 -31 -114 -40 -216 -27
-305 57 -398 358 -667 746 -668 288 0 572 176 699 435 57 116 75 186 82 315 8
156 -25 286 -108 428 -35 59 -177 209 -218 232 -13 7 9 -21 50 -61 69 -69 159
-188 159 -211 0 -6 -12 -2 -27 8 l-28 17 18 -26 c34 -52 8 -26 -43 43 -66 89
-157 171 -240 218 -122 68 -293 101 -427 81z m204 -32 c87 -19 231 -87 264
-125 17 -19 18 -22 4 -11 -35 29 -83 49 -102 43 -15 -5 -16 -4 -3 6 13 10 13
11 0 7 -8 -2 -15 -10 -15 -18 0 -8 -19 -33 -42 -57 -24 -24 -43 -47 -43 -52 0
-11 2 -11 -63 -15 -26 -2 -53 -8 -60 -13 -12 -10 -78 -22 -127 -24 -43 -1
-130 26 -172 54 -14 10 -40 18 -58 18 -29 0 -30 1 -16 16 18 17 21 28 6 19 -5
-3 -10 -1 -10 5 0 6 -5 8 -11 4 -6 -3 -15 -1 -20 7 -6 10 -17 6 -49 -20 -23
-18 -43 -31 -46 -28 -10 10 116 102 184 135 149 71 228 81 379 49z m-577 -201
c0 -2 -8 -10 -17 -17 -16 -13 -17 -12 -4 4 13 16 21 21 21 13z m819 -121 c8
-4 11 -112 11 -329 0 -267 -2 -326 -14 -335 -9 -7 -38 -11 -73 -9 l-58 3 -3
324 c-3 372 -5 360 78 356 27 -2 54 -6 59 -10z m-211 -167 c17 -17 17 -479 0
-496 -7 -7 -37 -12 -68 -12 -31 0 -61 5 -68 12 -9 9 -12 76 -12 240 0 215 1
229 20 248 23 23 108 28 128 8z m-198 -314 c0 -88 -4 -164 -10 -175 -9 -15
-22 -19 -65 -19 -90 0 -85 -9 -85 175 0 120 3 165 13 173 16 13 106 20 130 9
15 -7 17 -25 17 -163z m-225 -84 l0 -105 -49 -3 c-95 -6 -96 -5 -96 101 0 61
4 97 12 105 8 8 35 12 73 10 l60 -3 0 -105z"/>
<path d="M6960 3155 c-150 -34 -248 -85 -352 -183 -148 -140 -224 -309 -229
-510 -1 -32 -4 -44 -6 -29 -3 19 -10 27 -21 25 -30 -5 -27 43 13 232 2 14 -5
-2 -16 -35 -33 -93 -38 -275 -10 -386 70 -281 294 -502 578 -570 114 -27 281
-23 388 11 346 109 579 442 551 787 -10 116 -29 183 -85 298 -52 104 -124 196
-204 256 l-42 31 40 -39 c70 -68 88 -91 91 -118 1 -14 9 -37 18 -49 8 -13 -26
18 -77 69 -76 77 -108 100 -183 138 -50 25 -119 53 -154 62 -91 23 -221 28
-300 10z m190 -24 c39 -7 33 -9 -46 -10 -161 -2 -309 -54 -437 -154 -59 -46
-60 -46 -17 -7 91 85 207 144 325 165 82 15 114 16 175 6z m-160 -266 c79 -78
101 -80 178 -16 33 28 63 55 67 61 9 15 35 12 35 -4 0 -8 -27 -39 -60 -69 -33
-31 -60 -58 -60 -61 0 -4 68 -6 150 -6 157 0 200 -9 214 -45 3 -9 6 -131 6
-271 l0 -255 -25 -24 c-23 -24 -29 -25 -164 -25 -77 0 -142 -4 -145 -8 -10
-17 11 -29 62 -34 51 -5 97 -31 86 -49 -3 -5 -111 -9 -240 -9 l-235 0 3 22 c3
24 30 35 91 37 30 1 37 5 37 21 0 19 -7 20 -139 20 -134 0 -141 1 -168 24
l-28 24 3 264 c4 335 -14 308 204 308 87 0 158 4 158 8 0 4 -27 34 -60 67 -55
55 -65 75 -37 75 6 0 36 -25 67 -55z m-390 -930 c13 -14 21 -25 18 -25 -2 0
-15 11 -28 25 -13 14 -21 25 -18 25 2 0 15 -11 28 -25z"/>
<path d="M7015 2690 c-16 -7 -16 -9 -3 -9 23 -1 13 -31 -22 -70 l-29 -31 48 0
c44 0 49 -2 53 -25 6 -31 2 -35 -39 -35 l-33 0 0 -95 0 -95 -30 0 -30 0 0 95
0 95 -34 0 c-28 0 -35 4 -39 23 -4 21 -4 21 -6 1 -1 -18 -9 -23 -47 -29 -49
-7 -59 -2 -67 30 -3 11 -5 -52 -6 -141 -1 -112 3 -164 11 -172 9 -9 100 -12
350 -12 323 0 338 1 348 19 13 25 13 420 0 441 -8 12 -43 15 -207 17 -109 1
-207 -2 -218 -7z m150 -200 l32 -85 27 88 c26 84 28 87 56 87 17 0 30 -4 30
-9 0 -5 -12 -40 -26 -77 -14 -38 -33 -90 -40 -116 -14 -45 -17 -48 -49 -48
-30 0 -35 4 -49 43 -9 23 -27 73 -41 111 -32 88 -32 98 1 94 24 -3 31 -13 59
-88z"/>
<path d="M8855 3156 c-84 -16 -208 -66 -267 -108 -126 -89 -227 -222 -272
-359 -22 -65 -30 -110 -34 -198 -4 -103 -6 -111 -19 -90 -13 22 -14 17 -9 -51
l5 -75 -15 65 c-11 46 -14 98 -11 180 6 137 35 240 97 340 26 41 31 54 15 35
-41 -47 -105 -180 -126 -263 -13 -51 -19 -109 -19 -181 0 -409 326 -747 740
-768 145 -8 244 13 379 78 89 44 116 63 191 137 99 99 161 196 197 311 42 132
47 294 12 424 -40 150 -163 340 -263 409 -27 19 -26 16 10 -23 23 -24 44 -54
47 -67 6 -26 5 -26 -73 41 -161 139 -386 201 -585 163z m234 -32 c2 -2 -36 -4
-86 -4 -161 0 -311 -55 -436 -158 -71 -59 -111 -107 -154 -186 -37 -70 -45
-69 -9 2 116 230 368 374 616 355 36 -3 67 -7 69 -9z m-52 -240 c17 -5 23 -16
28 -53 6 -42 11 -50 41 -64 45 -22 51 -22 90 8 18 14 37 25 41 25 5 0 28 -20
52 -44 l43 -44 -29 -44 -30 -43 18 -40 c16 -35 23 -41 66 -50 48 -11 48 -11
51 -55 6 -75 -1 -87 -57 -94 -47 -6 -49 -7 -61 -51 -12 -42 -11 -46 14 -75 14
-18 26 -35 26 -40 0 -13 -79 -90 -92 -90 -7 0 -24 9 -38 20 -29 23 -42 24 -86
8 -28 -10 -34 -18 -40 -52 -9 -58 -19 -66 -80 -66 -59 0 -62 3 -72 62 -7 37
-12 44 -45 57 -35 13 -40 12 -82 -10 l-44 -24 -46 45 c-25 24 -45 47 -45 51 0
4 12 22 26 39 26 30 26 33 13 72 -7 22 -18 42 -23 44 -6 1 -30 8 -53 14 l-43
11 0 60 c0 55 2 60 26 69 14 6 36 10 48 10 18 0 27 10 41 46 l17 45 -30 38
-31 38 30 37 c48 58 64 62 110 30 39 -27 39 -27 78 -9 38 17 51 37 51 81 0 11
5 25 12 32 13 13 68 16 105 6z m-737 -719 c0 -5 -5 -3 -10 5 -5 8 -10 20 -10
25 0 6 5 3 10 -5 5 -8 10 -19 10 -25z"/>
<path d="M8900 2618 c-48 -33 -72 -70 -77 -121 -8 -66 4 -113 38 -152 66 -74
172 -83 246 -20 52 44 66 81 61 154 -7 103 -73 161 -181 161 -40 0 -63 -6 -87
-22z"/>
<path d="M5010 3137 c-33 -10 -33 -11 -10 -14 14 -2 39 3 55 11 23 12 25 16
10 15 -11 0 -36 -6 -55 -12z"/>
<path d="M5380 3132 c70 -20 110 -39 123 -59 4 -7 17 -13 27 -13 11 0 20 -4
20 -9 0 -5 24 -27 54 -51 66 -50 116 -111 87 -103 -11 3 -29 -1 -41 -7 -15 -8
-20 -8 -16 -1 4 7 -1 11 -13 11 -24 0 -29 -28 -8 -49 10 -10 8 -15 -6 -25 -10
-8 -15 -20 -11 -30 5 -13 -1 -16 -35 -16 -30 0 -41 -4 -41 -15 0 -32 -19 -13
-25 25 -4 22 -11 40 -16 40 -12 0 -12 -37 1 -45 6 -3 10 -12 10 -18 0 -7 -4
-6 -10 3 -6 10 -10 -4 -13 -45 -2 -43 -4 -33 -5 38 -1 53 -5 97 -9 97 -5 0 -7
-175 -5 -389 l2 -389 -24 -29 -24 -28 -188 -3 c-204 -4 -225 -1 -254 28 -19
19 -20 35 -21 223 -1 111 -4 227 -9 257 -7 54 -7 53 -10 -35 -2 -49 -5 -78 -7
-62 -2 15 -11 27 -19 27 -8 0 -14 -3 -14 -8 0 -13 -84 -45 -88 -33 -5 14 -32
15 -32 1 0 -5 -8 -10 -18 -10 -10 0 -27 -7 -38 -15 -10 -8 -27 -15 -36 -15 -9
0 -21 -6 -25 -13 -11 -18 -60 -37 -77 -31 -35 14 -33 208 4 329 40 130 107
233 207 319 27 22 49 45 50 50 1 5 27 25 60 44 32 18 49 31 38 27 -33 -10
-152 -85 -171 -107 -13 -14 -14 -19 -4 -13 9 5 12 4 7 -1 -5 -5 -16 -9 -25 -9
-19 0 -101 -99 -141 -170 -57 -101 -83 -191 -91 -320 -4 -66 -8 -99 -8 -74 -1
31 -7 49 -17 53 -11 4 -15 22 -16 63 l-2 58 -9 -70 c-20 -139 23 -336 103
-472 43 -73 178 -207 253 -252 32 -19 99 -50 149 -69 79 -30 108 -35 204 -40
123 -5 196 5 307 44 211 73 396 268 473 499 23 70 27 97 27 215 1 160 -12 221
-79 356 -32 66 -63 110 -111 160 -36 38 -52 52 -35 31 17 -21 28 -43 25 -49
-5 -7 -2 -8 7 -3 12 8 12 6 1 -8 -8 -9 -11 -22 -7 -29 4 -7 -2 -4 -12 8 -10
11 -48 47 -83 79 -76 68 -243 154 -311 161 -39 3 -37 2 21 -14z m-570 -105 c0
-2 -10 -12 -22 -23 l-23 -19 19 23 c18 21 26 27 26 19z"/>
<path d="M5615 2960 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M8389 2953 l-24 -28 28 24 c15 14 27 26 27 28 0 8 -8 1 -31 -24z"/>
<path d="M5415 2890 c21 -24 26 -25 19 -6 -3 8 -13 17 -22 21 -13 5 -13 2 3
-15z"/>
<path d="M5134 2838 c-3 -4 22 -8 55 -8 36 0 61 4 61 11 0 12 -108 10 -116 -3z"/>
<path d="M4995 2757 c-3 -7 -4 -138 -3 -292 l3 -280 194 -3 c149 -2 196 1 203
10 9 16 9 348 -2 438 l-7 65 -2 -90 c-1 -51 -5 -84 -9 -77 -7 10 -18 9 -53 -6
-24 -10 -64 -24 -89 -32 -25 -8 -56 -21 -70 -30 -14 -10 -37 -17 -52 -16 -16
1 -28 -2 -28 -6 0 -14 -31 -8 -36 7 -4 9 -14 14 -23 13 -14 -3 -16 15 -19 150
l-3 152 186 0 c183 0 186 0 195 -22 8 -22 9 -22 9 5 l1 27 -195 0 c-148 0
-197 -3 -200 -13z"/>
<path d="M6376 2745 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M2631 2594 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5154 2126 c-11 -29 1 -51 30 -54 36 -4 50 10 42 42 -5 21 -12 26
-37 26 -17 0 -32 -6 -35 -14z"/>
<path d="M3358 1490 c-19 -15 -21 -22 -12 -37 15 -24 38 -27 58 -8 21 22 20
42 -3 55 -15 7 -25 5 -43 -10z"/>
<path d="M3878 1499 c-25 -14 -23 -56 2 -64 12 -4 27 -1 35 5 20 16 19 56 -1
64 -19 7 -15 8 -36 -5z"/>
<path d="M7996 1494 c-9 -8 -16 -21 -16 -28 0 -16 20 -36 36 -36 14 0 44 27
44 40 0 11 -29 40 -40 40 -5 0 -16 -7 -24 -16z"/>
<path d="M8418 1499 c-20 -11 -24 -54 -7 -64 18 -12 56 4 62 25 3 11 -1 27
-10 35 -17 17 -22 18 -45 4z"/>
<path d="M10301 1496 c-21 -25 -10 -61 18 -61 31 0 50 28 35 53 -15 23 -38 26
-53 8z"/>
<path d="M5235 1485 c-50 -18 -100 -71 -114 -122 -15 -55 -13 -129 4 -163 31
-60 128 -79 195 -39 54 33 62 52 30 69 -16 9 -26 7 -47 -9 -32 -26 -74 -27
-104 -2 -44 35 -23 156 33 195 31 22 78 20 104 -5 21 -20 23 -20 48 -4 20 13
24 21 16 35 -25 46 -103 68 -165 45z"/>
<path d="M5722 1328 c-18 -95 -32 -176 -32 -180 0 -15 51 -8 56 7 5 13 8 13
27 0 51 -35 124 -8 156 58 25 51 27 106 6 146 -21 41 -72 54 -117 30 -20 -11
-20 -9 -13 36 3 26 9 54 12 61 4 10 -4 14 -29 14 l-34 0 -32 -172z m153 1 c13
-19 7 -79 -9 -104 -19 -29 -66 -34 -86 -10 -15 18 -5 83 17 108 18 19 68 23
78 6z"/>
<path d="M6013 1338 c-27 -148 -29 -165 -14 -181 22 -26 65 -19 69 12 2 13 -1
26 -6 30 -5 4 2 62 19 146 15 77 28 143 28 148 1 4 -14 7 -32 7 l-33 0 -31
-162z"/>
<path d="M9005 1488 c-2 -7 -16 -81 -31 -165 -30 -167 -27 -187 25 -181 24 3
26 7 24 43 -1 22 9 97 23 168 13 70 24 132 24 137 0 15 -60 12 -65 -2z"/>
<path d="M9328 1485 c-52 -18 -77 -51 -78 -102 0 -48 20 -69 94 -97 36 -14 46
-23 46 -40 0 -12 -5 -27 -12 -34 -20 -20 -79 -14 -105 10 l-23 21 -25 -23
c-32 -30 -32 -36 8 -60 23 -14 50 -20 96 -20 58 0 65 2 97 34 28 28 34 41 34
78 0 52 -15 70 -80 93 -70 25 -83 41 -54 69 20 21 73 20 96 -1 17 -15 19 -15
38 2 27 25 25 42 -7 58 -44 22 -85 26 -125 12z"/>
<path d="M1467 1353 c-15 -76 -29 -153 -33 -170 l-6 -33 88 0 c73 0 96 4 129
23 73 40 116 174 81 249 -25 52 -61 68 -153 68 l-80 0 -26 -137z m183 57 c26
-26 26 -81 1 -137 -11 -23 -28 -46 -39 -52 -29 -15 -102 -14 -102 2 0 13 29
174 36 195 6 20 81 15 104 -8z"/>
<path d="M3097 1448 c-52 -92 -157 -287 -157 -292 0 -4 15 -6 33 -6 28 0 36 5
50 35 17 35 17 35 82 35 57 0 65 -2 65 -19 0 -39 11 -51 47 -51 28 0 33 3 29
18 -8 27 -33 160 -47 245 l-12 77 -33 0 c-29 0 -36 -6 -57 -42z m56 -125 l5
-43 -39 0 c-21 0 -39 2 -39 5 0 2 12 30 27 60 30 60 35 58 46 -22z"/>
<path d="M6540 1476 c0 -8 -3 -21 -6 -30 -5 -13 2 -16 39 -16 25 0 48 -3 50
-7 3 -5 -6 -62 -19 -128 -31 -160 -31 -157 9 -153 l32 3 17 90 c10 50 22 114
28 143 l11 52 49 0 c47 0 59 11 60 53 0 4 -61 7 -135 7 -110 0 -135 -3 -135
-14z"/>
<path d="M6836 1458 c4 -18 19 -96 33 -173 l26 -140 35 0 35 0 83 160 c46 88
86 166 89 173 4 8 -6 12 -31 12 l-36 0 -61 -121 c-33 -67 -62 -119 -65 -116
-3 3 -43 217 -44 235 0 1 -16 2 -36 2 -35 0 -35 -1 -28 -32z"/>
<path d="M7660 1487 c0 -3 -13 -77 -30 -165 -16 -89 -30 -165 -30 -171 0 -19
150 -13 195 8 79 36 122 117 112 214 -3 38 -11 56 -36 80 -30 30 -36 32 -121
35 -50 2 -90 2 -90 -1z m154 -78 c20 -16 26 -29 26 -60 0 -85 -42 -136 -119
-144 -33 -3 -41 -1 -41 13 0 17 28 175 36 200 6 19 69 14 98 -9z"/>
<path d="M2137 1463 c-21 -3 -29 -11 -34 -34 -4 -20 -12 -29 -24 -29 -11 0
-19 -6 -19 -14 0 -8 -3 -21 -6 -30 -4 -11 -1 -16 11 -16 15 0 17 -6 10 -52
-14 -93 -12 -109 17 -131 36 -27 78 -17 78 18 0 19 -5 25 -21 25 -20 0 -21 4
-15 54 8 74 14 84 44 88 21 2 28 9 30 31 3 23 0 27 -22 27 -23 0 -24 3 -19 35
3 19 4 34 2 34 -2 -1 -17 -4 -32 -6z"/>
<path d="M3718 1463 c-22 -3 -28 -10 -28 -29 0 -17 -8 -27 -25 -34 -29 -11
-37 -60 -9 -60 12 0 15 -6 10 -22 -3 -13 -9 -51 -13 -84 -5 -58 -4 -63 20 -79
14 -9 38 -15 54 -13 22 2 29 9 31 31 3 21 -1 27 -17 27 -29 0 -32 10 -19 79
11 57 13 61 39 61 26 0 39 15 39 46 0 8 -10 14 -26 14 -25 0 -26 2 -21 35 3
19 3 34 -1 34 -4 -1 -19 -4 -34 -6z"/>
<path d="M8577 1463 c-22 -3 -29 -11 -34 -35 -4 -18 -14 -33 -25 -35 -10 -3
-18 -9 -18 -13 0 -5 -3 -15 -6 -24 -4 -11 -1 -16 11 -16 15 0 17 -7 10 -67 -4
-36 -9 -72 -12 -79 -9 -24 35 -55 75 -52 32 3 37 7 40 31 3 23 0 27 -22 27
-30 0 -30 5 -15 83 11 53 14 57 40 57 25 0 29 4 29 28 0 23 -4 28 -22 28 -20
-1 -22 3 -20 37 2 20 2 36 0 36 -2 -1 -16 -4 -31 -6z"/>
<path d="M1816 1369 c-56 -49 -73 -161 -30 -203 24 -25 60 -29 94 -13 16 9 30
11 30 6 0 -5 13 -9 30 -9 33 0 29 -9 59 140 11 52 17 98 15 102 -8 12 -52 9
-56 -3 -3 -9 -9 -9 -25 0 -38 20 -80 13 -117 -20z m104 -37 c42 -34 2 -132
-55 -132 -50 0 -52 100 -2 135 27 19 30 19 57 -3z"/>
<path d="M2288 1384 c-37 -20 -59 -65 -65 -135 -5 -52 -3 -60 20 -83 30 -30
62 -33 97 -9 17 12 25 13 28 5 2 -7 16 -12 31 -12 26 0 27 2 49 113 12 62 22
119 22 125 0 16 -57 15 -63 0 -4 -10 -7 -10 -18 0 -17 16 -68 15 -101 -4z m95
-97 c-2 -57 -25 -89 -61 -85 -34 4 -46 28 -38 71 9 48 31 69 70 65 30 -3 31
-4 29 -51z"/>
<path d="M3334 1388 c-3 -4 -15 -59 -27 -123 l-23 -115 33 0 c18 0 33 1 33 3
0 1 9 49 20 107 26 136 26 138 -6 136 -14 0 -28 -4 -30 -8z"/>
<path d="M3465 1389 c-4 -5 -15 -52 -26 -102 -10 -51 -21 -102 -24 -114 -5
-20 -2 -23 28 -23 l34 0 12 70 c15 83 42 124 78 117 17 -3 28 2 39 19 9 13 13
28 9 34 -9 15 -47 12 -72 -5 -19 -13 -22 -13 -27 0 -6 17 -42 20 -51 4z"/>
<path d="M3863 1392 c-7 -4 -22 -53 -33 -107 -11 -55 -23 -108 -26 -117 -4
-15 1 -18 28 -18 l34 0 22 108 c12 59 22 115 22 125 0 18 -25 23 -47 9z"/>
<path d="M3975 1387 c-2 -7 -11 -52 -20 -102 -9 -49 -19 -100 -22 -112 -4 -20
-1 -23 26 -23 27 0 31 4 40 38 6 20 13 56 17 80 8 50 26 72 59 72 33 0 36 -19
20 -106 -8 -41 -15 -78 -15 -80 0 -2 13 -4 29 -4 33 0 33 1 52 98 13 70 29 92
64 92 33 0 37 -21 20 -101 -19 -91 -20 -89 15 -89 23 0 31 5 35 23 32 141 33
179 5 207 -26 26 -80 26 -112 1 -24 -19 -24 -19 -36 0 -13 20 -50 24 -87 10
-11 -4 -35 -4 -53 0 -22 5 -35 3 -37 -4z"/>
<path d="M4419 1373 c-62 -52 -79 -149 -35 -200 21 -24 32 -28 78 -28 36 0 63
6 82 19 l28 18 -21 21 c-16 17 -23 19 -33 9 -15 -15 -70 -16 -86 0 -29 29 -13
38 72 38 l84 0 6 31 c7 37 -15 93 -42 108 -38 20 -98 13 -133 -16z m99 -35
c26 -26 13 -38 -40 -38 l-51 0 23 25 c26 27 49 32 68 13z"/>
<path d="M5475 1378 c-33 -26 -64 -91 -65 -136 0 -39 23 -87 45 -96 24 -9 68
-7 85 4 9 5 19 5 27 -1 6 -6 22 -9 35 -7 20 3 24 14 45 118 12 63 22 121 23
128 0 15 -57 16 -62 1 -3 -9 -9 -9 -25 0 -34 17 -78 13 -108 -11z m105 -53
c14 -16 6 -68 -16 -102 -18 -29 -69 -31 -84 -4 -13 25 -3 74 22 100 22 24 60
27 78 6z"/>
<path d="M6189 1377 c-41 -27 -61 -66 -67 -129 -4 -42 -1 -50 26 -78 25 -24
39 -30 74 -30 43 0 108 30 108 50 0 20 -35 29 -60 14 -34 -18 -47 -17 -70 6
-34 34 -24 40 64 40 91 0 96 3 96 62 0 19 -10 39 -29 59 -37 37 -92 39 -142 6z
m96 -47 c23 -26 16 -32 -40 -37 -51 -4 -62 14 -23 41 29 21 41 20 63 -4z"/>
<path d="M7974 1386 c-6 -16 -44 -219 -44 -233 0 -8 13 -13 29 -13 32 0 30 -6
64 177 l14 71 -30 5 c-16 2 -31 -1 -33 -7z"/>
<path d="M8150 1393 c-52 -19 -96 -115 -84 -180 12 -61 71 -87 137 -58 23 10
23 -16 -1 -46 -23 -27 -73 -30 -100 -6 -17 16 -20 16 -40 -6 l-22 -24 20 -18
c14 -12 41 -20 79 -23 55 -4 61 -2 96 29 35 33 37 40 65 179 16 79 26 148 24
152 -8 13 -41 9 -56 -6 -12 -11 -17 -11 -33 0 -19 14 -57 17 -85 7z m80 -62
c17 -11 17 -69 1 -100 -14 -25 -58 -38 -80 -24 -9 6 -17 26 -19 45 -5 61 52
107 98 79z"/>
<path d="M8396 1392 c-6 -9 -46 -218 -46 -238 0 -9 10 -14 29 -14 32 0 33 3
61 170 6 36 12 69 13 74 2 11 -51 18 -57 8z"/>
<path d="M8734 1381 c-63 -38 -89 -168 -45 -215 27 -29 87 -36 110 -13 11 10
14 10 18 0 3 -7 17 -13 32 -13 28 0 28 1 50 114 11 63 21 118 21 124 0 16 -51
21 -57 6 -4 -11 -9 -11 -26 1 -29 20 -66 19 -103 -4z m96 -56 c17 -21 6 -96
-16 -112 -25 -18 -71 -16 -78 3 -28 73 49 163 94 109z"/>
<path d="M9573 1380 c-82 -49 -94 -188 -21 -226 39 -20 120 -14 148 11 19 17
19 20 4 36 -15 17 -18 17 -50 2 -41 -20 -84 -6 -84 27 0 18 6 20 85 20 l85 0
0 46 c0 89 -87 133 -167 84z m91 -46 c26 -25 19 -32 -34 -36 -55 -3 -66 10
-28 36 28 20 43 20 62 0z"/>
<path d="M9791 1287 c-27 -147 -27 -147 8 -147 27 0 29 2 45 82 18 93 38 122
76 114 21 -4 30 1 43 23 9 16 14 31 10 35 -12 11 -58 6 -81 -10 -20 -14 -22
-14 -22 0 0 11 -9 16 -29 16 l-29 0 -21 -113z"/>
<path d="M9995 1391 c-2 -4 3 -36 10 -71 7 -36 18 -91 25 -122 11 -56 12 -58
43 -58 31 0 35 6 98 123 l66 122 -26 6 c-14 3 -29 4 -34 1 -4 -2 -26 -40 -49
-85 l-42 -82 -14 82 c-14 78 -16 81 -44 85 -16 3 -31 2 -33 -1z"/>
<path d="M10285 1390 c-7 -11 -45 -207 -45 -232 0 -13 8 -18 29 -18 l29 0 21
113 c27 143 27 147 -3 147 -14 0 -28 -4 -31 -10z"/>
<path d="M10440 1378 c-44 -29 -70 -80 -70 -136 0 -63 40 -102 105 -102 31 0
57 7 76 21 34 24 36 30 9 47 -17 10 -26 10 -50 -3 -34 -18 -65 -8 -74 23 -7
20 8 77 25 98 15 18 58 18 78 0 14 -13 19 -12 41 4 l25 19 -21 22 c-33 33
-100 36 -144 7z"/>
<path d="M10710 1393 c-51 -19 -90 -83 -90 -148 0 -66 39 -105 105 -105 45 0
105 22 105 39 0 4 -8 15 -17 24 -16 13 -21 14 -43 2 -34 -19 -54 -18 -73 3
-32 35 -21 42 67 42 l84 0 7 29 c8 36 -16 95 -43 110 -21 11 -76 13 -102 4z
m61 -53 c18 -10 27 -39 12 -41 -5 0 -25 -2 -45 -5 -47 -6 -56 9 -22 35 31 24
30 24 55 11z"/>
<path d="M10949 1385 c-14 -8 -32 -28 -39 -45 -17 -41 5 -73 62 -92 50 -17 62
-44 24 -54 -17 -4 -35 0 -52 11 -24 16 -27 16 -45 -1 -10 -9 -19 -21 -19 -25
0 -17 60 -39 105 -39 38 0 52 5 76 29 50 51 33 103 -43 125 -24 7 -44 20 -46
29 -5 23 34 31 68 13 28 -14 31 -13 45 7 21 30 19 34 -16 46 -43 15 -88 13
-120 -4z"/>
<path d="M2675 1355 c-51 -50 -17 -134 49 -121 40 8 66 40 66 82 0 61 -70 85
-115 39z"/>
<path d="M4806 1359 c-53 -42 -26 -129 42 -129 33 0 72 43 72 80 0 62 -63 89
-114 49z"/>
<path d="M7306 1359 c-53 -42 -26 -129 42 -129 33 0 72 43 72 80 0 62 -63 89
-114 49z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
